<template>
  <div>
    <div class="d-block d-sm-block d-md-none">
      <BannerTopMobile
        :image="detail ? detail.url_image_detail_mobile : ''"
      ></BannerTopMobile>
    </div>

    <div class="container mb-100" :style="`${!detail ? 'margin-bottom: 50%' : ''}`">
      <div v-if="detail">

        <!--escritorios-->
        <div class="d-none d-sm-none d-md-block">

          <div class="row">
            <div class="d-flex align-items-start justify-content-center col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <img class="mt-5-sm" :src="detail.url_image_detail" alt="">
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <h1 class="color-blue font-backward mb-5">{{ detail.name }}</h1>
              <p class="text-detail-flavor color-blue font-general-r" v-html="detail.description"></p>
            </div>
          </div>

          <div class="row mb-50 mt-10">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 d-flex justify-center flex-wrap container-variants">
              <div class="d-flex justify-content-center" v-if="detail.have_variants">
                <img
                  v-for="(variant, i) of detail.variants"
                  :key="i"
                  @click="selectSize(variant)"
                  :src="product_cart.variant_id == variant.id ? variant.attribute.url_icon.icon_selected : variant.attribute.url_icon.icon"
                  class="pointer icon_flask ml-5"
                />
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-detail-flavor mt-2 center-content-sm">
              <h4 class="color-blue font-general-r mb-5">
                <b v-if="detail.have_variants">
                  {{ currencyFormat(price * quantity_cart) }}
                </b>
                <b v-else>
                  {{ currencyFormat(detail.price * quantity_cart) }}
                </b>
              </h4>
              <div class="center-content-sm">
                <span class="color-blue font-general-r mb-5 h4">
                  CANTIDAD: {{ quantity_cart }}
                </span>
                <v-chip
                  v-if="exists_cart"
                  color="accent"
                  text-color="white"
                >
                  <v-avatar left>
                    <v-icon>mdi-shopping</v-icon>
                  </v-avatar>
                  Agregado en la bolsa
                </v-chip>

                <div class="d-flex center-justify-sm mb-5 mt-5">
                  <div class="container-quantity-cart">
                    <div class="buttons-actions-cart">
                      <v-icon @click="resQuantity" color="accent">mdi-minus</v-icon>
                      <span>{{ quantity_cart }}</span>
                      <v-icon @click="sumQuantity" color="accent">mdi-plus</v-icon>
                    </div>
                  </div>
                </div>
              </div>

              <small class="text-danger h6 font-general-r" v-if="!detail.exists_inventory">
                No disponible <br>
              </small>
              <v-btn
                @click="addToCart()"
                :loading="loading_btn"
                elevation="0"
                color="primary"
                class="nv-btn nv-btn-large nv-btn-hover"
                :disabled="!detail.exists_inventory"
              >AGREGAR AL CARRITO</v-btn>
            </div>
          </div>
        </div>

        <!--moviles-->
        <div class="d-block d-sm-block d-md-none">
          <div class="pa-sm-10">
            <h1 class="color-blue font-backward mb-5">{{ detail.name }}</h1>
            <p class="text-detail-flavor color-blue font-general-r" v-html="detail.description"></p>
          </div>

          <div class="row mb-50 mt-10">
            <div class="col-md-7 col-sm-12 col-12 center-content-sm container-variants">
              <div v-if="detail.have_variants">
                <img
                  v-for="(variant, i) of detail.variants"
                  :key="i"
                  @click="selectSize(variant)"
                  :src="product_cart.variant_id == variant.id ? variant.attribute.url_icon.icon_selected : variant.attribute.url_icon.icon"
                  :class="`pointer icon_flask ${i == 1 ? 'ml-5' : ''}`"
                />
              </div>
            </div>
            <div class="col-md-5 col-sm-12 col-12 text-detail-flavor mt-2 center-content-sm">
              <h4 class="color-blue font-general-r mb-2">
                <b v-if="detail.have_variants">
                  {{ currencyFormat(price * quantity_cart) }}
                </b>
                <b v-else>
                  {{ currencyFormat(detail.price * quantity_cart) }}
                </b>
              </h4>
              <div class="center-content-sm">
                <v-chip
                  v-if="exists_cart"
                  color="accent"
                  text-color="white"
                >
                  <v-avatar left>
                    <v-icon>mdi-shopping</v-icon>
                  </v-avatar>
                  Agregado en la bolsa
                </v-chip>

                <div class="container-quantity-cart mb-5 mt-2 m-auto">
                  <div class="buttons-actions-cart">
                    <v-icon @click="resQuantity" color="accent">mdi-minus</v-icon>
                    <span class="color-blue font-general-r">{{ quantity_cart }}</span>
                    <v-icon @click="sumQuantity" color="accent">mdi-plus</v-icon>
                  </div>
                </div>
              </div>

              <small class="text-danger h6 font-general-r" v-if="!detail.exists_inventory">
                No disponible <br>
              </small>
              <v-btn
                @click="addToCart()"
                :loading="loading_btn"
                elevation="0"
                color="primary"
                class="nv-btn nv-btn-large nv-btn-hover"
                :disabled="!detail.exists_inventory || !detail.status"
              >AGREGAR AL CARRITO</v-btn>
            </div>
          </div>

        </div>

        <NutritionalInformation v-if="detail.show_nutritional_info" :detail="detail"/>
      </div>

      <v-overlay :value="overlay">
        <img class="nv-loading" src="@/assets/store/nievedeolla.gif" alt="">
      </v-overlay>

      <SnackbarCart ref="snackbarCart"/>

      <PopupMessage ref="popupMessage" :message="message_popup"/>

    </div>

  </div>

</template>

<script>
import { currencyFormat } from '../helpers'
import HomePageService from '@/services/home.service'
import { mapState, mapGetters } from 'vuex'
import CartService from '@/services/cart.service'
import NutritionalInformation from '@/components/store/NutritionalInformation'

export default {
  components: { NutritionalInformation },
  data: () => ({

    message_popup: '',

    price: 0.00,
    added_cart: false,
    detail: null,
    overlay: false,
    loading_btn: false,

    product_cart: {
      option_size: '',
      qty: 1,
      product: '',
      price: 0.00,
      variant_id: ''
    },

    quantity_cart: 1,
    exists_cart: false

  }),
  watch: {
    quantity_cart(newVal) {
      if (newVal < 1) {
        this.quantity_cart = 1
      }
    }
  },
  computed: {
    ...mapState(['cart', 'is_auth']),
    ...mapGetters(['total_cart'])
  },
  methods: {
    sumQuantity() {
      this.quantity_cart++
    },
    resQuantity() {
      if (this.quantity_cart >= 1) {
        this.quantity_cart--
      }
    },
    getAddToCart(product_id) {
      let match = false
      let item = {}
			this.cart.cart_products.forEach(i => {
				if (i.product.id == product_id) {
					match = true
          item = i
				}
      })
      if (match) {
        this.quantity_cart = parseInt(item.quantity)
        this.product_cart.option_size = item.option_size
        this.product_cart.variant_id = item.variant_id
        this.price = parseFloat(item.price)
        this.exists_cart = true
      }
		},
    addToCart() {
      this.$validator.validateAll().then(async result => {
        if (result) {
          try {
            if (this.detail.have_variants && !this.product_cart.option_size) {
              this.$refs.popupMessage.openDialog()
              this.message_popup = 'Debes elegir un tamaño para tu helado'
              return false
            } else {
              this.loading_btn = true
              const { data:res } = await CartService.verifiedStock(
                this.detail.id,
                this.product_cart.variant_id,
                this.quantity_cart
              )
              if (!res.success) {
                this.loading_btn = false
                this.$refs.popupMessage.openDialog()
                this.message_popup = 'La cantidad elegida no esta disponible'
                return false
              }

              this.product_cart.qty = this.quantity_cart
              if (this.detail.have_variants) {
                this.product_cart.price = parseFloat(this.price)
              } else {
                this.product_cart.price = parseFloat(this.detail.price)
              }

              this.$store.dispatch('addItemCart', this.product_cart)

              setTimeout(() => {
                this.loading_btn = false
                this.getAddToCart(this.detail.id)
                this.$refs.snackbarCart.open()
              }, 500)
            }
          } catch (error) {
            console.log(error)
            this.loading_btn = false
            this.$refs.popupMessage.openDialog()
            this.message_popup = 'En estos momentos nieve de olla no esta disponible'
          }
        }
      })
		},
    selectSize(variant) {
      this.product_cart.option_size = variant.attribute.name
      this.price = variant.price
      this.product_cart.variant_id = variant.id
      //this.product_cart = JSON.parse(JSON.stringify(this.product_cart))
    },
    async getFlavorDetail() {
      try {
        this.overlay = true
        const { data:res } = await HomePageService.getFlavorDetail(this.$route.params.id)
        this.detail = res
        this.product_cart.product = this.detail
        setTimeout(() => {
          this.getAddToCart(this.detail.id)
          this.overlay = false
        }, 1000)
      } catch (error) {
        this.overlay = false
      }
    },
    currencyFormat(price) {
			return currencyFormat(price)
		}
  },
  mounted() {
    this.getFlavorDetail()
  }
}
</script>

<style scoped>
@media only screen and (min-width: 1720px) and (max-width: 3000px) {
  >>>.v-snack__content {
    padding: 36px 40px !important;
  }
}

</style>
